import { useTranslation } from "react-i18next";
import { Modal } from "../Modal/Modal";
import { Button } from "../Button/Button";
import styles from "./ConfirmDialog.module.css";

interface ConfirmDialogProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	title?: string;
	message?: string;
	isLoading?: boolean;
	confirmDisabled?: boolean;
	children?: React.ReactNode;
}

export function ConfirmDialog({
	isOpen,
	onClose,
	onConfirm,
	title,
	message,
	isLoading,
	confirmDisabled,
	children,
}: ConfirmDialogProps) {
	const { t } = useTranslation();
	return (
		<Modal isOpen={isOpen} onClose={onClose} title={title || t("confirm")}>
			<p className={styles.message}>{message || t("confirm")}</p>
			{children}
			<div className={styles.actions}>
				<Button variant="ghost" onClick={onClose}>
					{t("cancel")}
				</Button>
				<Button
					variant="danger"
					onClick={onConfirm}
					isLoading={isLoading}
					disabled={confirmDisabled}
				>
					{t("confirm")}
				</Button>
			</div>
		</Modal>
	);
}
